<template>
  <div class="flex flex-wrap mb-2">
    <div class="w-3/4 flex-1 bg-white rounded-xl space-y-6 p-6" style="position:relative">
      <div class="grid grid-cols-12">
        <span>前進模式</span>
        <div class="col-span-10 text-sm leading-6 text-gray-400">開啟時，若階段1的成效表現良好，則同時開啟階段1後的所有階段</div>
        <div>
          <InputSwitch :disabled="editPageType" v-model="viewDatalistData.useDoForward" class="float-right"/>
        </div>
      </div>
    </div>
    <div class="w-1/4 rounded-xl space-y-2 px-4" style="width:425px;"></div>
  </div>
</template>
<script>
  import InputSwitch from 'primevue/inputswitch';

  export default {
    name: 'StageDoForward',
    props: {
      editPage: {
        type: Boolean
      },
      viewDatalist: {
        type: Object
      },
      lang: {
        type: Object
      },
    },
    components: {
      InputSwitch
    },
    data() {
      return {
        useDynBudget: false
      }
    },
    created() {

    },
    watch:{
      'viewDatalistData.useDoForward':function(v){
        console.log('viewDatalistData.useDoForward');
        console.log(v);
      },
    },
    methods: {

    },
    computed: {
      editPageType: {
        get: function () {
          return this.editPage
        },
        set: function (value) {
          this.$emit('update:editPageType', value)
        },
      },
      viewDatalistData: {
        get: function () {
          return this.viewDatalist
        },
        set: function (value) {
          this.$emit('update:viewDatalistData', value)
        },
      }
    }
  }
</script>

<style lang="scss" scoped>
  ::v-deep(.calendar-group) {
    .p-calendar .p-inputtext {
      padding: 0.25rem;
      border: 0px;
    }
  }
</style>